module.exports = __webpack_public_path__ + "img/busca-tematica-animales.fbcc7fdf.jpg";